  //on lp cart icon click send to cart page
  // let lpCartIcon = document.querySelector('.lp-cart-icon');
  // if(lpCartIcon){
  //     // console.log('lpCartIcon', lpCartIcon);
  //     lpCartIcon.addEventListener('click', function(){
  //         // let originalCartIcon = document.querySelector('.site-header__cart.js-mini-cart.cardraw .js-toggle-cart');
  //         // console.log('originalCartIcon', originalCartIcon);   
  //         // originalCartIcon.click();
  //         location.href = '/cart';
  //     });
  // }


  //differenceSlider slider
  $("#differenceSlider").owlCarousel({
      loop: true,
      margin: 20,
      dots: true,
      nav: false,
      navText: [
      ``,
      ``
      ],
      autoplay: true,
      autoplayTimeout: 4000,
      autoplayHoverPause: true,
      responsive: {
          0: {
              items: 1.2,
              center: true,
          },
          600: {
              items: 2.1,
          },
          1000: {
              items: 2.5,
          },
          1200: {
              items: 3,
          }
      }
  });
  

  $("#imgWithBackground").owlCarousel({
        loop: true,
      margin: 10,
      nav: false,
      dots: true,
      autoplay: true,
      autoplayTimeout: 4000,
      responsive:{
        0:{ items: 1.2 },
        600:{ items: 2.2 },
        1000:{ items: 3.2 },
        1200:{ items: 4 }
      }
  });


  //LP featured product - widget script
  const plans = document.querySelectorAll('.subscription-box .subscription');
  if(plans){
    plans.forEach(plan => {
        plan.addEventListener('click', () => {
          const oneTimePlan = document.querySelector('.subscription-box .one-time-plan');
          if(oneTimePlan){
            oneTimePlan.classList.remove('active');
          }
          plans.forEach(p => p.classList.remove('active'));
          plan.classList.add('active');4
          //update selling_plan id
          let selling_plan_input = document.querySelector('input[name="selling_plan"]');
          if(selling_plan_input){
              let active_selling_plan_id = plan.getAttribute('data-selling-plan-id');
              selling_plan_input.value = active_selling_plan_id;
          }   
        });
    });
  }

  const oneTimePlan = document.querySelector('.subscription-box .one-time-plan');
  if(oneTimePlan){
      oneTimePlan.addEventListener('click', () => {
        oneTimePlan.classList.add('active');
        const plans = document.querySelectorAll('.subscription-box .subscription');
        if(plans){
          plans.forEach(p => p.classList.remove('active'));
        }
        let selling_plan_input = document.querySelector('input[name="selling_plan"]');
        if(selling_plan_input){
          selling_plan_input.value = '';
        }
      });                    
  }
  //LP featured product - widget script ends


//DOM load starts
document.addEventListener('DOMContentLoaded', function(){

    // Select all CTA buttons
    const ctaButtons = document.querySelectorAll('.ctaBTN');
    // Attach click event to each button
    if(ctaButtons){
        ctaButtons.forEach(button => {
            button.addEventListener('click', event => {
                event.preventDefault(); // prevent default jump

                // Get href value (like "#shopTrioSection")
                const targetId = button.getAttribute('href');

                // Make sure it's a valid section id
                if (targetId && targetId.startsWith('#')) {
                const targetSection = document.querySelector(targetId);
                if (targetSection) {
                    // Smooth scroll to that section
                    targetSection.scrollIntoView({
                    behavior: 'smooth',
                    block: 'start'
                    });
                }
                }
            }); 
        });
    }


    //shop trio add to cart + apply discount code
    // const shopCTAButtons = document.querySelectorAll('[data-product-cta="shopLPProduct"]');
    // if (!shopCTAButtons.length) return;

    // shopCTAButtons.forEach(button => {
    //     button.addEventListener('click', async (e) => {
    //     // Prevent default and stop the event from bubbling to the document-level handler
    //     e.preventDefault();
    //     e.stopPropagation();
    //     if (typeof e.stopImmediatePropagation === 'function') {
    //         e.stopImmediatePropagation();
    //     }

    //     // Optional: if your element is an <a>, add this class so theme.js also skips it
    //     // (theme.js checks for .disabled-anchor)
    //     button.classList.add('disabled-anchor');

    //     const variantId = button.getAttribute('data-product-variant-id');
    //     const discountCode = button.getAttribute('data-product-discount');

    //     if (!variantId) {
    //         console.error('Missing product variant ID.');
    //         return;
    //     }

    //     try {
    //         // disable button UX
    //         const prevDisabled = button.disabled;
    //         button.disabled = true;
    //         const prevText = button.innerHTML;
    //         button.innerHTML = 'Adding...';

    //         // Add to cart via Shopify AJAX
    //         const addToCartRes = await fetch('/cart/add.js', {
    //         method: 'POST',
    //         headers: {'Content-Type': 'application/json'},
    //         body: JSON.stringify({ id: variantId, quantity: 1 }),
    //         });

    //         if (!addToCartRes.ok) {
    //         const err = await addToCartRes.json().catch(() => ({}));
    //         throw new Error(err.description || 'Failed to add product to cart.');
    //         }

    //         // Redirect (apply discount if present)
    //         if (discountCode) {
    //         window.location.href = `/discount/${encodeURIComponent(discountCode)}?redirect=/checkout`;
    //         } else {
    //         window.location.href = '/cart';
    //         }
    //     } catch (error) {
    //         console.error('Error adding product to cart:', error);
    //         // restore button
    //         button.disabled = false;
    //         // restore text
    //         // (you may want to show an error UI instead)
    //         // button.innerHTML = prevText;
    //     }
    //     }, false); // use bubbling listener on the element
    // });


    //count up animation
    // const wrappers = document.querySelectorAll('.new-percentage-text-wrap');
    // if (!wrappers.length) return;

    // const animateCount = (el, target) => {
    //     let start = 0;
    //     const duration = 1500; // 1.5 seconds
    //     const startTime = performance.now();

    //     const step = (currentTime) => {
    //     const progress = Math.min((currentTime - startTime) / duration, 1);
    //     const value = Math.floor(progress * target);
    //     el.textContent = value + '%';
    //     if (progress < 1) requestAnimationFrame(step);
    //     };

    //     requestAnimationFrame(step);
    // };

    // const observer = new IntersectionObserver(
    //     (entries, observer) => {
    //     entries.forEach(entry => {
    //         if (entry.isIntersecting) {
    //         const texts = entry.target.querySelectorAll('.b-text-1');

    //         texts.forEach(textEl => {
    //             const text = textEl.textContent.trim();
    //             const numberMatch = text.match(/\d+/); // extract number part
    //             if (numberMatch) {
    //             const targetValue = parseInt(numberMatch[0]);
    //             animateCount(textEl, targetValue);
    //             }
    //         });

    //         observer.unobserve(entry.target); // run only once per element
    //         }
    //     });
    //     },
    //     { threshold: 0.3 } // trigger when 30% of element is visible
    // );

    // wrappers.forEach(wrap => observer.observe(wrap));


});//dom load event ends







/* My JS Start */
document.addEventListener('DOMContentLoaded', function(){
    $('.video-reviews-slider').slick({
       dots: false,
       arrows: false,
       slidesToShow: 3,
       slidesToScroll: 1,
       autoplay: false,
       prevArrow: '<img class="slick-arrow slick-prev" src="https://happyaging.com/cdn/shop/t/143/assets/lp-icon-8.png">',
       nextArrow: '<img class="slick-arrow slick-next" src="https://happyaging.com/cdn/shop/t/143/assets/lp-icon-7.png">',
       infinite: true,
       responsive: [
         {
           breakpoint: 1250,
           settings: {
             slidesToShow: 2,
             slidesToScroll: 1,
             infinite: true,
           }
         },
         {
           breakpoint: 990,
           settings: {
             slidesToShow: 2,
             slidesToScroll: 1,
             dots: false,
           }
         },
         {
           breakpoint: 551,
           settings: {
             slidesToShow: 1,
             slidesToScroll: 1,
             dots: true,
           }
         }
       ]
    });

    $('.lp-shot-review-slider .bottom').slick({
      slidesToShow: 4,
      infinite: true,
      slidesToScroll: 1,
      autoplay: false,
      prevArrow: '<img class="slick-arrow slick-prev" src="https://happyaging.com/cdn/shop/t/143/assets/lp-icon-8.png">',
      nextArrow: '<img class="slick-arrow slick-next" src="https://happyaging.com/cdn/shop/t/143/assets/lp-icon-7.png">',
      centerMode: true,
      autoplaySpeed: 2000,
      dots: true,
      arrows: false,
      responsive: [
        {
          breakpoint: 1500,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 1,
          },
        },
        {
          breakpoint: 1200,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 1,
          },
        },
        {
          breakpoint: 768,
          settings: {
            slidesToShow: 1.5,
            slidesToScroll: 1,
          },
        },
        {
          breakpoint: 550,
          settings: {
            slidesToShow: 1.5,
            slidesToScroll: 1,
          },
        },
        {
          breakpoint: 450,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
          },
        },
        {
          breakpoint: 400,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
          },
        },
      ],
    });

    let faqWrapper = document.querySelectorAll('.faq-inner-wrapper');
    if(faqWrapper){
      faqWrapper.forEach(heading => {
        heading.addEventListener('click', (event) => {
            event.stopPropagation();
            const faqWrapper = heading.closest('.main-faq-wrapper');
            const textarea = faqWrapper.querySelector('.faq-textarea');
            const isActive = faqWrapper.classList.contains('active');
            document.querySelectorAll('.main-faq-wrapper').forEach(el => {
                el.classList.remove('active');
                el.querySelector('.faq-textarea').style.maxHeight = null; // Collapse all
            });
            
            if (!isActive) {
                faqWrapper.classList.add('active');
                textarea.style.maxHeight = textarea.scrollHeight + "px"; // Expand the active one
            } else {
                faqWrapper.classList.remove('active');
                textarea.style.maxHeight = null; // Collapse it
            }
        });
      });
    }
   // Video Play Pause JS starts
    document.querySelectorAll('.pause-image').forEach(image => {
      image.addEventListener('click', function() {
        let video = this.closest('.video-box').querySelector('.main-video');

        // Pause all other videos
        document.querySelectorAll('.main-video').forEach(v => {
          if (v !== video) {
            v.pause();
            v.currentTime = 0; // optional: reset other videos
            v.closest('.video-box').querySelector('.pause-image').style.display = "block";
          }
        });

        // Play the clicked video
        video.play();
        this.style.display = "none"; // Hide the pause image
      });
    });

    // Pause video when clicking on it
    document.querySelectorAll('.main-video').forEach(video => {
      video.addEventListener('click', function() {
        this.pause();
        let pauseImage = this.closest('.video-box').querySelector('.pause-image');
        pauseImage.style.display = "block"; // Show the pause image again
      });

      // When the video ends, show the pause image again
      video.addEventListener('ended', function() {
        let pauseImage = this.closest('.video-box').querySelector('.pause-image');
        pauseImage.style.display = "block";
      });
    });
    // Video Play Pause JS ends

  const $slider = $('.blocks-assets-slider');

  // Initialize Slick first
  $slider.slick({
    dots: false,
    arrows: false,
    slidesToShow: 4,
    slidesToScroll: 1,
    autoplay: false,
    infinite: true,
    responsive: [
      {
        breakpoint: 1250,
        settings: { slidesToShow: 2 }
      },
      {
        breakpoint: 990,
        settings: { slidesToShow: 2 }
      },
      {
        breakpoint: 551,
        settings: { slidesToShow: 1, dots: true, }
      }
    ]
  });
});
$(window).on('load', function () {

  // Function to apply +width to the first slide
  function applyExtraWidth() {
    const $slider = $('.blocks-assets-slider');
    if (!$slider.length) return;
    let $firstSlide = $slider.find('.slick-slide[data-slick-index="0"]');
    let defaultWidth = $firstSlide.outerWidth();

    if (!defaultWidth || defaultWidth === 0) return;

    if (window.innerWidth <= 550) {
      let newWidth = defaultWidth * 1;
      $firstSlide.css('width', newWidth + 'px');
    } else {
      let newWidth = defaultWidth + 100;
      $firstSlide.css('width', newWidth + 'px');
    }

    $firstSlide.addClass('fixed-first-slide');
  }

  setTimeout(applyExtraWidth, 400);

  // --- Handle window resize (debounced) ---
  let resizeTimer;
  $(window).on('resize', function () {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(function () {
      applyExtraWidth();
    }, 1000); // wait 300ms after resize stops
  });
});

